module.exports = __webpack_public_path__ + "static/img/RWA954-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWA954-G_1.png
// module id = 8AiL
// module chunks = 0